var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import PageService from '../../api/PageService';
import KeyConfig from './KeyConfig.vue';
import TableExpandList from "./TableExpandList.vue";
var TableList = (function (_super) {
    __extends(TableList, _super);
    function TableList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.expandFilter = [];
        _this.colmuns = [];
        _this.multiColmuns = [];
        _this.dataSource = [];
        _this.total = 0;
        _this.tableKey = 1;
        _this.summaryDetail = {};
        return _this;
    }
    TableList.prototype.watchCols = function (newCols, oldCols) {
        console.log('newCols:%o', newCols);
        if (newCols) {
            this.colmuns = newCols;
            this.renderTable();
        }
    };
    TableList.prototype.created = function () {
        this.service = PageService.getInstance();
        this.loadingInstance = Loading.service({ fullscreen: true });
        this.getPageConfig(this.fetch);
    };
    TableList.prototype.renderTable = function () {
        this.tableKey = Math.random();
    };
    TableList.prototype.initColmun = function (colmuns) {
        var _this = this;
        var freezeIndex = colmuns.findIndex(function (item) { return item.is_freeze; });
        colmuns.map(function (item, index) {
            if (_this.filterColumns.includes(item.key)) {
                item.rowHidden = true;
                item.is_hidden = 1;
            }
            if (item.type && colmuns[index + 1] && item.type === colmuns[index + 1].type) {
                item.freezeDisabled = true;
            }
            if (index <= freezeIndex) {
                item.fixed = true;
            }
            else {
                item.fixed = false;
            }
            return item;
        });
        if (this.isMultiHeader) {
            var multiColmuns = _.cloneDeep(colmuns);
            this.multiColmuns = this.multiColmunsSet(multiColmuns);
        }
        return colmuns;
    };
    TableList.prototype.configUpdate = function (configData) {
        this.colmuns = this.initColmun(configData);
        this.renderTable();
    };
    TableList.prototype.showKeyConfig = function () {
        this.$refs.KeyConfig.show(this.colmuns, this.templateType);
    };
    TableList.prototype.getPageConfig = function (callBack) {
        var _this = this;
        if (!this.isShowKeyConfig)
            return callBack();
        this.service
            .getPage({
            template_type: this.templateType,
        })
            .then(function (res) {
            var DATA = res.data.data;
            _this.colmuns = Array.isArray(DATA.template_config) ? _this.initColmun(DATA.template_config) : [];
            callBack();
        })
            .catch(function (err) {
            _this.loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    TableList.prototype.layoutTable = function () {
        var _this = this;
        this.$nextTick(function () {
            var table = _this.$refs.Table;
            table.resizeListener();
            _this.$nextTick(function () {
                var fixedLeft = table.$el.querySelector('.el-table__fixed');
                var fixedRight = table.$el.querySelector('.el-table__fixed-right');
                if (fixedLeft) {
                    fixedLeft.style.height = (table.layout.tableHeight - table.layout.gutterWidth) + 'px';
                }
                if (fixedRight) {
                    fixedRight.style.height = (table.layout.tableHeight - table.layout.gutterWidth) + 'px';
                }
            });
        });
    };
    TableList.prototype.fetch = function (pager, updatePager, renderTable) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        if (renderTable === void 0) { renderTable = true; }
        if (pager.page === 1 && this.$refs.pagination && !updatePager)
            this.$refs.pagination.clear();
        this.fetchAction(Object.assign({}, this.filter, __assign({}, pager, { sort_field: this.order ? this.order[0] : null, sort_type: this.order ? this.order[1] : null })))
            .then(function (res) {
            _this.loadingInstance.close();
            var DATA = res.data;
            _this.dataSource = Array.isArray(DATA.data) ? DATA.data : [];
            _this.layoutTable();
            _this.$emit('fetchCallBack', res.data);
            _this.total = DATA.total;
            renderTable && _this.renderTable();
        })
            .catch(function (err) {
            _this.loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    TableList.prototype.fetchCallBack = function (data) {
        console.log(data);
        this.total = data.total;
        this.summaryDetail = {
            order_detail_money_count: data.order_detail_money_count,
            order_detail_no_tax_money_count: data.order_detail_no_tax_money_count,
            order_detail_tax_money_count: data.order_detail_tax_money_count,
            order_detail_settlement_money_count: data.order_detail_settlement_money_count,
            refund_order_detail_money_count: data.refund_order_detail_money_count,
            refund_order_detail_no_tax_money_count: data.refund_order_detail_no_tax_money_count,
            refund_order_detail_tax_money_count: data.refund_order_detail_tax_money_count,
            order_detail_amount_count: data.order_detail_amount_count,
            order_detail_goods_money_count: data.order_detail_goods_money_count,
            order_detail_reduction_money_count: data.order_detail_reduction_money_count,
            cost_money_count: data.cost_money_count,
            gross_profit_count: data.gross_profit_count,
            goods_nums_count: data.goods_nums_count,
            order_money_count: data.order_money_count,
        };
    };
    TableList.prototype.getExpandSummaries = function (param) {
        var _this = this;
        console.log(this.summaryDetail);
        console.log(111);
        var sums = [];
        var setSummary = function (value, key) {
            var index = param.columns.findIndex(function (item) { return item.label === value; });
            if (index !== -1)
                sums[index] = _this.summaryDetail[key];
        };
        setSummary('实付金额（含税）', 'order_detail_money_count');
        setSummary('未税金额', 'order_detail_no_tax_money_count');
        setSummary('税额', 'order_detail_tax_money_count');
        setSummary('数量', 'order_detail_amount_count');
        setSummary('应付金额', 'order_detail_goods_money_count');
        setSummary('成本金额', 'cost_money_count');
        setSummary('优惠金额', 'order_detail_reduction_money_count');
        setSummary('毛利额', 'gross_profit_count');
        if (!sums.length)
            return null;
        sums[0] = '合计';
        return sums;
    };
    TableList.prototype.expandChange = function (row, expandedRows) {
        if (expandedRows.length == 0) {
            return;
        }
        this.expandFilter[this.expandKey] = row[this.expandKey];
    };
    TableList.prototype.pageChange = function (pager) {
        this.fetch(pager, true);
    };
    TableList.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (prop) {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        else {
            this.order = null;
        }
        this.fetch({ page: 1, start: 0, limit: 20 }, false, false);
    };
    __decorate([
        Prop({
            default: document.documentElement.clientHeight - 250,
        })
    ], TableList.prototype, "tableHeight", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "cols", void 0);
    __decorate([
        Prop({
            required: true,
        })
    ], TableList.prototype, "fetchAction", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "dataActions", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "sortColumns", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "filterColumns", void 0);
    __decorate([
        Prop({
            default: {},
        })
    ], TableList.prototype, "filter", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableList.prototype, "showSummary", void 0);
    __decorate([
        Prop({
            default: function () { },
        })
    ], TableList.prototype, "setSummary", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableList.prototype, "isShowKeyConfig", void 0);
    __decorate([
        Prop({
            default: 1,
        })
    ], TableList.prototype, "templateType", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "renderTitleKeys", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "renderContentKeys", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableList.prototype, "isMultiHeader", void 0);
    __decorate([
        Prop({
            default: function () { },
        })
    ], TableList.prototype, "multiColmunsSet", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableList.prototype, "showExpand", void 0);
    __decorate([
        Prop({
            default: function () { },
        })
    ], TableList.prototype, "expandAction", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableList.prototype, "expandKey", void 0);
    __decorate([
        Prop({
            default: 1,
        })
    ], TableList.prototype, "expandTemplateType", void 0);
    __decorate([
        Prop({
            default: function () { },
        })
    ], TableList.prototype, "setExpandSummary", void 0);
    __decorate([
        Watch('cols', { immediate: true })
    ], TableList.prototype, "watchCols", null);
    TableList = __decorate([
        Component({
            components: {
                TableExpandList: TableExpandList,
                KeyConfig: KeyConfig,
            },
        })
    ], TableList);
    return TableList;
}(Vue));
export default TableList;
